import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAuthUser } from "../redux/auth/authSlice";
import {
  getModulePermissions,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
} from "../utils/permissions";
import { isSuperAdmin } from "../utils/userRole";

export function usePermissions() {
  const user = useSelector(selectAuthUser);

  const can = useCallback(
    (permissionSlug) => hasPermission(user, permissionSlug),
    [user],
  );

  const canAny = useCallback(
    (permissionSlugs) => hasAnyPermission(user, permissionSlugs),
    [user],
  );

  const canAll = useCallback(
    (permissionSlugs) => hasAllPermissions(user, permissionSlugs),
    [user],
  );

  const superAdmin = useMemo(() => isSuperAdmin(user), [user]);

  const modulePermissions = useCallback(
    (module) => getModulePermissions(user, module),
    [user],
  );

  return {
    user,
    isSuperAdmin: superAdmin,
    can,
    canAny,
    canAll,
    modulePermissions,
    permissionSlugs: user?.permissionSlugs || [],
    roles: user?.roles || [],
    permissions: user?.permissions || [],
  };
}
